// extracted by mini-css-extract-plugin
module.exports = {"sponsored-text":"sponsored_sponsored-text__bvYij"};